import React, { useState } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';

import { SimpleAppBar } from '_lib/components/AppBar/SimpleAppBar';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { AppRouteContext } from '../App/app.types';
import { appRoutePaths, getFullAppRoutePath, hasGoBack } from '../Nav/nav.types';

import { CompanyUpdate } from './CompanyUpdate/CompanyUpdate';

export const CompanyDetailRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();

  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();

  const [goBackState] = useState(() => {
    if (hasGoBack(location.state)) {
      return location.state.goBack;
    }
    return undefined;
  });

  const [companyName, setCompanyName] = useState('');

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar
        title={`Company Detail${companyName ? ` - (${companyName})` : ''}`}
        onBackClicked={() => {
          if (goBackState) {
            navigate(goBackState.url);
          } else {
            navigate(getFullAppRoutePath(appRoutePaths.Company));
          }
        }}
        onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer}
      />
      <CompanyUpdate companyId={id} setCompanyName={setCompanyName} />
    </FlexBox>
  );
};
